<template>
    <a-modal centered :visible="visible" :title="type == '账号已存在' ? '温馨提示' : '注册成功'" :footer="null" @cancel="show">
        <div class="content-div">
            <span>{{type == '账号已存在'? '您已有麦德通账号，无需注册，请您移步到电脑登录，' : '恭喜您注册成功，请在电脑上登录使用，麦德通系统。'}}登录链接：https://user.ippmaster.com/</span>
            <a-button type="primary" class="btn" @click="copy">复制</a-button>
        </div>
        <div class="footer-div">
            <a-button type="primary" @click="show">{{type == '账号已存在' ? '确定': '我知道了'}}</a-button>
        </div>
    </a-modal>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                type: undefined
            }
        },
        methods: {
            show(type) {
                this.visible = !this.visible
                if(!this.visible) {
                    setTimeout(() => {
                        this.type = type
                    },100)
                } else {
                    this.type = type
                }
            },
            copy() {
                this.$copyText('https://user.ippmaster.com/').then(message => {
                    this.$message.success('复制成功')
                }).catch(err => {
                    console.log('copy.err', err)
                    this.$message.error('复制失败')
                })
            }
        }
    }
</script>

<style scoped>
    .content-div{
        line-height: 38px;
    }
    .btn{
        margin-left: 6px;
    }
    .footer-div{
        width: 100px;
        margin: 30px auto 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/registeredTipsModal/index.vue